import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AppMainComponent } from 'src/app/app.main.component';
import { getWBPermissionStatus } from 'src/app/misc/workspace/models/get-wb-permission-status';
import { Permission, User } from 'src/app/misc/workspace/models/workbook-permission.modal';

@Component({
  selector: 'app-assign-users',
  // standalone: false,
  // imports: [],
  templateUrl: './assign-users.component.html',
  styleUrl: './assign-users.component.scss'
})
export class AssignUsersComponent implements OnInit, OnChanges {

  displayUsers: boolean = false;
  activeUsers: any; //reassignUsers
  selectedUsers: any[] = []; //selectedReassignUserTB

  //Input decorator
  @Input() selectedUsersList: any;
  @Input() displayUsersPopup: boolean = false;
  @Input() singleSelection:boolean = false;
  @Input() isPermission:boolean = false; //for WB permission check
  @Input() permissions?: Permission[] = []; //WB permission object
  //output  decorator
  @Output() saveAssignDataclicked = new EventEmitter();
  @Output() cancelClicked = new EventEmitter();
  @ViewChild('dt1') dt1: Table;
  @ViewChild('searchInput') searchInput: ElementRef

  //pagination
  tableShowMore: number[] = [15, 30, 50, 100];
  pageSize: number = 15;
  firstPage: number = 0;
  first: number = 0;
  lsttotalRecords: number = 1;
  getWBPermissionStatus = getWBPermissionStatus

  constructor(
    public app: AppMainComponent,
  ) { }

  ngOnInit(): void {

    this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);
    this.lsttotalRecords = this.activeUsers?.length;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedUsersList && changes.selectedUsersList.currentValue) {
      this.selectedUsers = changes.selectedUsersList.currentValue;
      if(this.isPermission&& this.activeUsers &&this.permissions){
        this.updateWBPermissionsInActiveUsers();
      }
    }

    if (changes.displayUsersPopup && changes.displayUsersPopup.currentValue) {
      this.displayUsers = changes.displayUsersPopup.currentValue;
    }

  }

  saveAssignUser() {
    this.displayUsers = false;
    this.saveAssignDataclicked.emit({
      selectedUsers:  [... new Set(this.selectedUsers)],
    })
  }

  closeUserAssignPopup() {
    this.displayUsers = false;
    this.cancelClicked.emit();
  }

  clearSearchInput(): void {
    // Clear the value of the input field
    if (this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.value = '';
      // Reset the table filter
      this.dt1.reset();
    }

  }

  onSingleRowSelect($event: any){
    if(this.singleSelection){
        this.selectedUsers = [$event.data];
        this.saveAssignUser();
    }
}
updateWBPermissionsInActiveUsers() {
  const loggedUserId = this.app.user?.userId;

  this.activeUsers = this.activeUsers
    ?.filter(activeUser => activeUser?.id !== loggedUserId)
    ?.map(activeUser => {
      // Check if user is explicitly assigned
      const explicitPermission = this.permissions.find(permission =>
        permission.users.some((u: User) => u.userId === activeUser.id)
      );

      if (explicitPermission) {
        return {
          ...activeUser,
          permissionType: explicitPermission.permissionType,
          permissionName: explicitPermission.name
        };
      }

      // Check if any permission is shared with everyone
      const sharedPermission = this.permissions.find(permission =>
        permission.isSharedWithEveryone
      );

      if (sharedPermission) {
        return {
          ...activeUser,
          permissionType: sharedPermission.permissionType,
          permissionName: sharedPermission.name
        };
      }

      // No permission
      return {
        ...activeUser,
        permissionType: null
      };
    });
}


}
